<!-- Mobile Menu -->
<div class="mobile-menu-container" *ngIf="i18n && i18n._ && siteContent && portraitMode" [class.expanded]="portraitModeMenuOpened">
    <app-menu [siteContent]="siteContent" [selectedOption]="selectedOption" (selectedOptionChange)="onSelectedOptionChange($event)"
    (highlightedOptionChange)="onHighlightedOptionChange($event)"></app-menu>
</div>
<!-- <div class="slogan portrait" *ngIf="i18n && i18n._ && portraitMode && selectedOption == null">
    <div class="slogan-line">{{i18n._.SLOGAN.LINE_1}}</div>
    <div class="slogan-line last">{{i18n._.SLOGAN.LINE_2}}</div>
</div> -->
<div class="header-options-mobile" *ngIf="i18n && i18n._ && portraitMode">
    <div class="header-option" (click)="openBrandDialog()">{{i18n._.BRAND}}</div>
    <div class="header-option" (click)="openConceptDialog()">{{i18n._.CONCEPT}}</div>
</div>
<div class="main" *ngIf="i18n && i18n._ && siteContent" [class.blurred]="dialogContent != null">
    <!--Header-->
    <div class="header">
        <div class="logo" (click)="togglePortraitModeMenu()"><div class="logo-toggle" *ngIf="portraitMode"></div></div>
        <div class="language-selector">
            <app-dropdown [dropdownOptions]="languageOptions" [selectedOptionId]="selectedLanguage" (selectedOptionChange)="onLanguageChange($event)"></app-dropdown>
        </div>
    </div>
    <!--Body-->
    <div class="body" [class.blurred]="portraitMode && portraitModeMenuOpened">
        <div class="left-panel" *ngIf="!portraitMode">
            <div class="menu-container">
                <app-menu [siteContent]="siteContent" [selectedOption]="selectedOption" (selectedOptionChange)="onSelectedOptionChange($event)"
                (highlightedOptionChange)="onHighlightedOptionChange($event)"></app-menu>
            </div>
        </div>
        <div class="center-panel">
            <app-cube-contents [content]="selectedOptionContent"></app-cube-contents>
            <app-cube [siteContent]="siteContent" [highlightedCube]="highlightedOption" [selectedCubeInfo]="selectedOptionInfo" (selectedCubeChange)="onSelectedOptionChange($event)"></app-cube>
        </div>
        <div class="right-panel" *ngIf="!portraitMode">
            <app-right-menu></app-right-menu>
            <!-- <div class="slogan">
                <div class="slogan-line">{{i18n._.SLOGAN.LINE_1}}</div>
                <div class="slogan-line last">{{i18n._.SLOGAN.LINE_2}}</div>
            </div> -->
        </div>
    </div>
    <!--Footer-->
    <app-footer [class.blurred]="portraitMode && portraitModeMenuOpened"></app-footer>
</div>
<!--Dialog-->
<app-dialog [title]="dialogTitle" [content]="dialogContent" *ngIf="dialogContent"></app-dialog>
<!--Popup-->
<app-popup [args]="popupArgs"></app-popup>